import keyMirrorList from '../../utils/keyMirrorList'

const COLUMN_TYPES = keyMirrorList([
  'TEXT',
  'FILTER',
  'VALUE_TEXT',
  'HTML',
  'DATE',
  'BOOL',
  'TIME',
  'CURRENCY',
  'CHECKBOX',
  'STATUS',
  'ACTION',
  'LABEL',
  'CUSTOM',
  'NUMBER',
])

const COLUMN_SORT_SETTING = {
  NOT_SORTABLE: -1,
  NOT_SORTED: 0,
  SORTED: 1,
}

/**
 * This is good for two reasons:
 * - it gives us a standard unit for the default rendering of all columns in tables across all products
 * - Gives us names default breakpoints, in the same way we try and use standard breakpoints for media queries
 */
const COLUMN_STANDARD_SIZES = {
  XSMALL: 40,
  SMALL: 100,
  MEDIUM: 200,
  LARGE: 300,
}

const DATE_OPTION_TYPES = {
  CALENDAR: 'CALENDAR',
  TODAY: 'TODAY',
  TOMORROW: 'TOMORROW',
  YESTERDAY: 'YESTERDAY',
  THIS_WEEK: 'THIS_WEEK',
  NEXT_WEEK: 'NEXT_WEEK',
  LAST_WEEK: 'LAST_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  NEXT_MONTH: 'NEXT_MONTH',
  LAST_MONTH: 'LAST_MONTH',
}

const DATE_OPTIONS = [
  { text: 'Select from Calendar', value: DATE_OPTION_TYPES.CALENDAR },
  { text: 'Today', value: DATE_OPTION_TYPES.TODAY },
  { text: 'Tomorrow', value: DATE_OPTION_TYPES.TOMORROW },
  { text: 'Yesterday', value: DATE_OPTION_TYPES.YESTERDAY },
  { text: 'This Week', value: DATE_OPTION_TYPES.THIS_WEEK },
  { text: 'Next Week', value: DATE_OPTION_TYPES.NEXT_WEEK },
  { text: 'Last Week', value: DATE_OPTION_TYPES.LAST_WEEK },
  { text: 'This Month', value: DATE_OPTION_TYPES.THIS_MONTH },
  { text: 'Next Month', value: DATE_OPTION_TYPES.NEXT_MONTH },
  { text: 'Last Month', value: DATE_OPTION_TYPES.LAST_MONTH },
]

export {
  COLUMN_TYPES,
  COLUMN_SORT_SETTING,
  COLUMN_STANDARD_SIZES,
  DATE_OPTION_TYPES,
  DATE_OPTIONS,
}
